export const RESERVATION_STATUS = {
  Confirmed: 'Confirmed',
  InvitationPending: 'InvitationPending',
  InvitationDeclined: 'InvitationDeclined',
  InvitationExpired: 'InvitationExpired',
  InvitationCancelled: 'InvitationCancelled',
  InvitationOverwritten: 'InvitationOverwritten',
} as const;
